<template>
    <div class="registry">
        <!-- <h1>Registras</h1> -->
        <!-- <p>Galimų komponentų sąrašas</p> -->
        <b-button @click="showComponents = !showComponents" variant="link"
            >Toggle components</b-button
        >
        <b-button @click="showOutput = !showOutput" variant="link"
            >Toggle output</b-button
        >
        <b-button @click="preloadOutput()" variant="link"
            >Preload output</b-button
        >
        <b-button @click="saveOutput()" variant="link">Save structure</b-button>
        <b-button @click="$refs.loadOutput.show()" variant="link"
            >Load structure</b-button
        >
        <b-button @click="saveRendered()" variant="link"
            >Save rendered</b-button
        >
        <b-button @click="renderAndSaveAll()" variant="link"
            >Render & Save</b-button
        >

        <b-form-group
            label="Project name:"
            label-cols-sm="2"
            label-cols-lg="2"
            class="mx-3 border px-2 py-1"
        >
            <b-input
                v-model="projectName"
                class="col-sm-4 float-left"
            ></b-input>
            <b-button
                @click="renderPreview()"
                variant="link"
                :disabled="rendering"
                :class="{ 'bg-warning': rendering }"
                >{{ rendering ? "Rendering..." : "Render preview" }}</b-button
            >
            <b-button @click="viewBuildLog()" variant="link">Show log</b-button>
            <a :href="projectPreviewLink" target="_blank" class="mx-2"
                >Preview link</a
            >
            <a :href="projectZipLink" target="_blank" class="mx-2">Get zip</a>
            <br />
            <div class="small pt-1">
                <label class="font-weight-bold d-inline m-0 mr-2"
                    >Install mode:</label
                >
                <b-form-radio
                    v-model="installMode"
                    name="install-mode"
                    value="default"
                    class="d-inline mr-2"
                    >default</b-form-radio
                >
                <b-form-radio
                    v-model="installMode"
                    disabled
                    name="install-mode"
                    value="skip"
                    class="d-inline mr-2"
                    >skip install</b-form-radio
                >
                <b-form-radio
                    v-model="installMode"
                    name="install-mode"
                    value="full"
                    class="d-inline mr-2"
                    >full reinstall</b-form-radio
                >

                <label class="font-weight-bold d-inlin m-0 mr-2"
                    >Build mode:</label
                >
                <b-form-radio
                    v-model="buildMode"
                    name="build-mode"
                    value="prod"
                    class="d-inline mr-2"
                    >production</b-form-radio
                >
                <b-form-radio
                    v-model="buildMode"
                    name="build-mode"
                    value="dev"
                    class="d-inline mr-2"
                    >development</b-form-radio
                >
                <b-form-checkbox
                    id="no-sample-data"
                    class="d-inline mr-2"
                    v-model="noDemoData"
                    name="no-sample-data"
                    >No demo data</b-form-checkbox
                >
            </div>
        </b-form-group>

        <b-container fluid>
            <b-row>
                <b-col cols="3">
                    <draggable
                        v-if="showComponents"
                        class="border p-1"
                        tag="div"
                        :group="{ name: 'people', pull: 'clone' }"
                        :list="plugins"
                        :clone="clonePlugin"
                    >
                        <div
                            class="list-group-item p-0"
                            v-for="(plugin, index) in plugins"
                            :key="index"
                        >
                            <div class="d-flex px-2">
                                <label class="my-auto">{{
                                    plugin.tag || plugin.id
                                }}</label>
                                <div class="ml-auto">
                                    <!-- <span class="badge">{{plugin.order}}</span> -->
                                    <b-button
                                        @click="toggleExpand(plugin.uid)"
                                        variant="link"
                                        >Show info</b-button
                                    >
                                </div>
                            </div>
                            <b-collapse v-model="box[plugin.uid]">
                                <b-card class="mx-2 mb-2 bg-light">
                                    <pre>{{ plugin }}</pre>
                                </b-card>
                            </b-collapse>
                        </div>
                    </draggable>
                </b-col>
                <b-col cols="9">
                    <nested-draggable
                        :key="componentParamsChanged"
                        tag="div"
                        class="border p-1"
                        :list="output"
                        group="people"
                        @edit="editComponentHandler"
                        @render="renderHandler"
                        @edit-attribute="editAttributeHandler"
                        @add-attribute="addAttributeHandler"
                        @remove="removeItemHandler"
                    ></nested-draggable>
                </b-col>
            </b-row>
        </b-container>
        <!-- <b-button @click="$refs.loadCustom.show()" variant="link">Preload custom</b-button> -->

        <!-- <template v-for="(plugin, index) in plugins">
      <div :key="index" class="border m-3">
        <div class="d-flex px-2">
          <label class="my-auto">{{ plugin.tag }}</label>
          <b-button class="ml-auto" @click="toggleExpand(index)" variant="link">Toggle Collapse</b-button>
        </div>
        <b-collapse v-model="box[index]">
          <b-card class="mx-2 mb-2 bg-light">
            <pre>{{ plugin }}</pre>
          </b-card>
        </b-collapse>
      </div>
		</template>-->

        <pre v-if="showOutput">{{ output }}</pre>

        <property-editor
            v-model="editableAttribute"
            ref="propertyEditor"
            :tag="editableTag"
            @saved="savePropertyHandler"
            @removed="removePropertyHandler"
        ></property-editor>

        <component-editor
            ref="componentEditor"
            v-model="editableComponent"
            @saved="saveComponentHandler"
            :component-import-base="componentImportBase"
        ></component-editor>

        <div class="w-100">
            <b-button
                v-if="rederedComponent"
                @click="saveRendered(rederedComponent)"
                variant="link"
                >Save rendered</b-button
            >
            <highlight language="html">{{ renderedOutput }}</highlight>
        </div>

        <b-modal
            ref="loadOutput"
            title="Load some content"
            @ok="useImportedData"
            size="lg"
        >
            <b-form-file
                v-model="file"
                :state="Boolean(file)"
                placeholder="Choose a file or drop it here..."
                drop-placeholder="Drop file here..."
                accept=".txt, .json"
                @change="loadOutput"
            ></b-form-file>
            <div class="mt-3">Selected file: {{ file ? file.name : "" }}</div>
            <highlight language="json">{{ fileContent }}</highlight>
        </b-modal>

        <b-modal
            ref="logModal"
            title="Build log information"
            size="xl"
            hide-footer
        >
            <!-- Install Lint Build -->
            <pre class="rounded p-2 bg-light">{{ buildLog }}</pre>
        </b-modal>

        <!-- <b-modal ref="loadCustom">
      <b-textarea v-model="output"></b-textarea>
		</b-modal>-->
    </div>
</template>

<script>
import draggable from "vuedraggable";
import NestedDraggable from "@/components/NestedDraggable";
import PropertyEditor from "@/components/PropertyEditor";
import ComponentEditor from "@/components/ComponentEditor";
import { mapGetters, mapActions } from "vuex";
import hljs from "highlight.js";
import Highlight from "vue-highlight-component";
import "highlight.js/styles/github.css";
import jsFileDownload from "js-file-download";
import JSZip from "jszip";

import packageJsonContent from "@/components/defaults/preset1/package_json.js";
import babelConfigContent from "@/components/defaults/preset1/babel_config_js.js";
import readmeMdContent from "@/components/defaults/preset1/readme_md.js";
import registerServiceWorkerContent from "@/components/defaults/preset1/registerServiceWorker_js.js";
import mainJsContent from "@/components/defaults/preset1/main_js.js";
import homeVueContent from "@/components/defaults/preset1/home_vue.js";
import aboutVueContent from "@/components/defaults/preset1/about_vue.js";
import indexJsContent from "@/components/defaults/preset1/index_js.js";
import indexHtmlContent from "@/components/defaults/preset1/index_html.js";

export default {
    name: "registry",
    components: {
        draggable,
        NestedDraggable,
        PropertyEditor,
        ComponentEditor,
        Highlight
    },
    data() {
        return {
            noDemoData: false,
            buildLog: {},
            installMode: "default",
            buildMode: "prod",
            rendering: false,
            projectName: "test1",
            file: [],
            fileContent: "",
            editableAttribute: {},
            editableComponent: {},
            editableUid: 0,
            editableTag: "",
            showComponents: true,
            showOutput: false,
            output: [],
            renderedOutput: "",
            box: {},
            editable: true,
            isDragging: false,
            delayedDragging: false,
            renderOptions: {
                data: [],
                props: [],
                methods: []
            },
            itemData: {},
            itemComputed: {},
            componentImportStrings: {},
            componentRegistrationStrings: {},
            componentParamsChanged: 0,
            componentImportBase: "@/",
            rederedComponent: ""
        };
    },

    computed: {
        ...mapGetters({
            plugins: "registry/getPlugins",
        }),
        dragOptions() {
            return {
                animation: 0,
                group: "description",
                disabled: !this.editable,
                ghostClass: "ghost",
                clone: original => {
                    return original;
                }
            };
        },
        listString() {
            return JSON.stringify(this.list, null, 2);
        },
        list2String() {
            return JSON.stringify(this.list2, null, 2);
        },
        projectPreviewLink() {
            if (process.env.NODE_ENV === "production") {
                return `https://vpm.monas.lt/api/projects/${this.projectName}/dist/`;
            }

            return `http://localhost/vue-panel-maker/api/projects/${this.projectName}/dist/`;
        },
        projectZipLink() {
            if (process.env.NODE_ENV === "production") {
                return `https://vpm.monas.lt/api/projects/${this.projectName}/zip.src`;
            }

            return `http://localhost/vue-panel-maker/api/projects/${this.projectName}/zip.src`;
        }
    },
    methods: {
        ...mapActions({
            setPlugins: "registry/setPlugins"
        }),
        setOutput(data) {
            this.output = data;
        },
        preloadOutput() {
            this.setOutput([
                {
                    id: "data-source",
                    uid: 7,
                    tag: "data-source",
                    props: [
                        {
                            name: "type",
                            type: "Object",
                            value: "srcObj",
                            defaultValue: "",
                            renderOption: "dynamic",
                            requiresSpecial: "data"
                        },
                        {
                            name: "bind",
                            type: "Boolean",
                            value: "false",
                            defaultValue: "false",
                            renderOption: "boolean"
                        }
                    ],
                    slots: false,
                    events: ["loginSuccess", "loginError"],
                    order: 3,
                    importAs: "local",
                    importName: "dataSource",
                    importPath: "components/dataSource"
                },
                {
                    id: "page",
                    uid: 5,
                    tag: "plug-page",
                    props: [
                        {
                            name: "page-name",
                            type: "String",
                            value: "",
                            defaultValue: "",
                            renderOption: "static"
                        },
                        {
                            name: "bind",
                            type: "Boolean",
                            value: "false",
                            defaultValue: "false",
                            renderOption: "boolean"
                        }
                    ],
                    slots: {
                        default: [
                            {
                                id: "page",
                                uid: 6,
                                tag: "plug-page",
                                props: [
                                    {
                                        name: "page-name",
                                        type: "String",
                                        value: "",
                                        defaultValue: "",
                                        renderOption: "static"
                                    },
                                    {
                                        name: "bind",
                                        type: "Boolean",
                                        value: "false",
                                        defaultValue: "false",
                                        renderOption: "boolean"
                                    },
                                    {
                                        name: "bindObject",
                                        type: "Object",
                                        value: "bindObj",
                                        defaultValue: "",
                                        renderOption: "dynamic",
                                        requiresSpecial: "data"
                                    },
                                    {
                                        name: "bindArray",
                                        type: "Array",
                                        value: "bindArr",
                                        defaultValue: "",
                                        renderOption: "dynamic",
                                        requiresSpecial: "data"
                                    },
                                    {
                                        name: "onCLick",
                                        type: "String",
                                        value: "onClickListener",
                                        defaultValue: "onClickListener",
                                        renderOption: "listener",
                                        requiresMethod: true
                                    }
                                ],
                                slots: {
                                    default: [
                                        // {
                                        //     id: "login",
                                        //     uid: 8,
                                        //     tag: "plug-login",
                                        //     props: [
                                        //         {
                                        //             name: "user",
                                        //             type: "Object",
                                        //             value: "{}",
                                        //             defaultValue: "() => {}",
                                        //             renderOption: "static"
                                        //         },
                                        //         {
                                        //             name: "bind",
                                        //             type: "Boolean",
                                        //             value: "false",
                                        //             defaultValue: "false",
                                        //             renderOption: "static"
                                        //         }
                                        //     ],
                                        //     slots: false,
                                        //     events: [
                                        //         "loginSuccess",
                                        //         "loginError"
                                        //     ],
                                        //     order: 0,
                                        //     importAs: "local",
                                        //     importName: "login",
                                        //     importPath: "components/login"
                                        // }
                                    ],
                                    footer: []
                                },
                                events: ["logout"],
                                order: 2,
                                importAs: "local",
                                importName: "plugPage2",
                                importPath: "components/plugPage2"
                            }
                        ],
                        footer: []
                    },
                    events: ["logout"],
                    order: 2,
                    importAs: "local",
                    importName: "plugPage",
                    importPath: "views/plugPage",
                    isRoutable: true,
                    route: "example-route",
                    routeLink: "Example link"
                }
            ]);
        },
        countArrayComponents(componentArray) {
            if (!componentArray.length) {
                return 0;
            }

            let count = 1;
            componentArray.forEach(component => {
                if (Object.keys(component.slots).length) {
                    let slots = Object.keys(component.slots);
                    slots.forEach(slot => {
                        count += this.countArrayComponents(
                            component.slots[slot]
                        );
                    });
                }
            });

            return count;
        },
        saveRendered(componentName = "main") {
            jsFileDownload(this.renderedOutput, componentName + ".vue");
        },
        renderAndSaveAll() {
            this.zipAll().then(content => {
                // see FileSaver.js
                jsFileDownload(content, "src.zip");
            });
        },
        viewBuildLog() {
            this.$refs.logModal.show();
        },
        zipAll() {
            let zip = new JSZip();
            // first we need to add default app files
            // package.json
            zip.file("package.json", packageJsonContent);

            // babel.config.js
            zip.file("babel.config.js", babelConfigContent);

            // readme.md
            zip.file("readme.md", readmeMdContent);

            // src folder and it's content
            let srcFolder = zip.folder("src");

            // registerServieWorker.js
            srcFolder.file(
                "registerServiceWorker.js",
                registerServiceWorkerContent
            );

            // main.js
            srcFolder.file("main.js", mainJsContent);
            // main.scss
            srcFolder.file(
                "main.scss",
                `.cursor-pointer {
    cursor: pointer;
}`
            );

            // App.vue, router and views cntent should be adjusted to our structure

            let viewsFolder = srcFolder.folder("views");

            if (!this.noDemoData) {
                viewsFolder.file("Home.vue", homeVueContent);
                viewsFolder.file("About.vue", aboutVueContent);
            }

            // store/index.js
            let storeFolder = srcFolder.folder("store");
            storeFolder.file("index.js", indexJsContent);

            // public folder
            let publicFolder = zip.folder("public");
            publicFolder.file("index.htm", indexHtmlContent);

            // call component iterator to render all local components into folders acording to import path
            // iterate output and render
            let renderedComponents = this.renderComponentArrayToFile(
                this.output
            );
            let folders = [];
            let filesInFolders = {};
            let routableComponents = [];
            let routeDefinitions = [];
            let rootPageImport = []; // this will be used to import first component in non dynamic fashion
            let routeLinks = [];

            if (!this.noDemoData) {
                // some default routes for demo purposes only
                routeLinks.push('<router-link to="/">Home</router-link>');
                routeLinks.push('<router-link to="/about">About</router-link>');
            }

            renderedComponents.forEach(renderedComponent => {
                // console.log("compo", renderedComponent);

                // check if renderedComponent is routable and pick up some info if it is so
                if (renderedComponent.isRoutable) {
                    routableComponents.push(renderedComponent);


                    // check if this is root path
                    if (renderedComponent.route === '/') {
                        rootPageImport.push(`import RootPageComponent from "../${renderedComponent.path}";`);

                        routeDefinitions.push(`
                        {
        path: "/${renderedComponent.route.substring(1)}",
        name: "root",
        component: RootPageComponent
      }`);
                    routeLinks.push(`
                    <router-link to="/">${renderedComponent.routeLink}</router-link>
                    `);
                    } else {
                        routeDefinitions.push(`
                        {
        path: "/${renderedComponent.route}",
        name: "${renderedComponent.route}",
        component: () =>
          import(/* webpackChunkName: "${renderedComponent.route}" */ "@/${renderedComponent.path}")
      }`);

                    routeLinks.push(`
                    <router-link to="/${renderedComponent.route}">${renderedComponent.routeLink}</router-link>
                    `);
                    }

                }

                // check if path is deeper and add some folders
                if (renderedComponent.path.indexOf("/") !== -1) {
                    // get real import folder - drop last part after /
                    let pathSplit = renderedComponent.path.split("/");
                    pathSplit.pop();
                    let folderPath = pathSplit.join("/");
                    if (folders.indexOf(folderPath) === -1) {
                        folders.push(folderPath);
                    }
                    if (filesInFolders[folderPath] === undefined) {
                        filesInFolders[folderPath] = [];
                    }
                    filesInFolders[folderPath].push(renderedComponent);
                } else {
                    srcFolder.file(
                        renderedComponent.file,
                        renderedComponent.content
                    );
                }
            });

            // console.log("subfolder", folders, filesInFolders);
            // let componentsFolder = srcFolder.folder("components");
            folders.forEach(folder => {
                if (filesInFolders[folder] !== undefined) {
                    // let folderZip = componentsFolder.folder(folder);
                    let folderZip = srcFolder.folder(folder);
                    // add folder and iterate over filesInFolder
                    filesInFolders[folder].forEach(fileInFolder => {
                        folderZip.file(fileInFolder.file, fileInFolder.content);
                    });
                }
            });
            // @todo: iterate over subfolders and zip the content

            // now we must add routable components here
            let routerFolder = srcFolder.folder("router");

            let routeIndexContent = `
            import Vue from "vue";
import VueRouter from "vue-router";
${rootPageImport}

Vue.use(VueRouter);

const routes = [
  `;


            if (!this.noDemoData) {
                routeIndexContent = `import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes = [
    {
    path: "/",
    name: "home",
    component: Home
  },
  {
    path: "/about",
    name: "about",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue")
  },`;
            }

            routeIndexContent = `${routeIndexContent}
            ${routeDefinitions.join(",")}
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;`;

            routerFolder.file("index.js", routeIndexContent);

            // App.vue
            srcFolder.file(
                "App.vue",
                `<template>
  <div id="app">
    <div id="nav">
      ${routeLinks.join(" | ")}
    </div>
    <router-view />
  </div>
</template>
`
            );

            // vue.config.js
            let pathToProject = `/vue-panel-maker/api/projects/${this.projectName}/dist/`;
            if (process.env.NODE_ENV === "production") {
                pathToProject = `/api/projects/${this.projectName}/dist/`;
            }

            zip.file(
                "vue.config.js",
                `module.exports = {
publicPath: '${pathToProject}'
}`
            );

            zip.file(
                ".env",
                `VUE_APP_API_BASE=https://vpm.monas.lt/api/
`
            );

            // default .htaccess file to farce preview hit to dist folder
            zip.file(
                ".htaccess",
                `RewriteEngine On
RewriteBase /
RewriteRule ^index\.html$ - [L]
RewriteCond %{REQUEST_FILENAME} !-f
RewriteCond %{REQUEST_FILENAME} !-d
RewriteRule . /index.html [L]`
            );

            // let componentsFolder = zip.folder("components");
            // // componentsFolder.fle("login.vue");
            return zip.generateAsync({ type: "blob" });
            // .then(function(content) {
            //     return content;
            //     // // see FileSaver.js
            //     // jsFileDownload(content, "src.zip");
            // });
        },
        /**
         * This should make same zip and send it to the API for rendering the preview
         */
        renderPreview() {
            this.rendering = true;
            this.zipAll().then(content => {
                var formData = new FormData();
                // var imagefile = document.querySelector("#file");
                formData.append("zip", content);
                formData.append("projectName", this.projectName);
                formData.append("build", this.buildMode);
                formData.append("install", this.installMode);
                this.axios
                    .post("?action=buildPreview", formData, {
                        headers: {
                            "Content-Type": "multipart/form-data"
                        }
                    })
                    .then(response => {
                        this.buildLog = response.data;
                    })
                    .catch(error => {
                        this.buildLog = error.data;
                    })
                    .finally(() => {
                        this.rendering = false;
                        this.$refs.logModal.show();
                    });
            });
        },
        /**
         * Will render component array as seperate files
         */
        renderComponentArrayToFile(componentArray) {
            let result = [];
            componentArray.forEach(element => {
                // top level
                if (element.importAs === "local") {
                    // zip.file(
                    //     `${element.importName}.vue`,
                    //     this.componentRenderer(element)
                    // );
                    result.push({
                        file: `${element.importName}.vue`,
                        content: this.componentRenderer(element),
                        path: `${element.importPath}`,
                        isRoutable: element.isRoutable || false,
                        route: element.route || "",
                        routeLink: element.routeLink || ""
                    });
                }
                // next levels
                if (element.slots && Object.keys(element.slots).length) {
                    Object.keys(element.slots).forEach(slotElement => {
                        // result.push({
                        result = [
                            ...result,
                            ...this.renderComponentArrayToFile(
                                element.slots[slotElement]
                            )
                        ];

                        // })
                    });
                }
            });

            return result;
        },
        saveOutput() {
            jsFileDownload(JSON.stringify(this.output), "structure.json");
        },
        loadOutput(e) {
            // load file`s content into output
            const file = e.target.files[0];
            const reader = new FileReader();

            // reader.onload = e => this.$emit("load", e.target.result);
            reader.onload = e =>
                (this.fileContent = JSON.stringify(
                    JSON.parse(e.target.result),
                    null,
                    2
                ));
            this.fileContent = reader.readAsText(file);
        },
        useImportedData() {
            this.setOutput(JSON.parse(this.fileContent));
        },
        generateAppFiles() {
            // try to use saveOutput approuch to generate zip file from tmp created file structure
        },
        toggleExpand(uid) {
            if (this.box[uid]) {
                this.box[uid] = false;
                return false;
            }

            this.box[uid] = true;
            return true;
        },
        orderList() {
            this.list = this.list.sort((one, two) => {
                return one.order - two.order;
            });
        },
        onMove({ relatedContext, draggedContext }) {
            const relatedElement = relatedContext.element;
            const draggedElement = draggedContext.element;
            return (
                (!relatedElement || !relatedElement.fixed) &&
                !draggedElement.fixed
            );
        },
        /**
         * makes cloned copy of plugin
         */
        clonePlugin(item) {
            const a = JSON.parse(JSON.stringify(item));
            let cloned = Object.assign({}, a);
            cloned.uid = this.generateUUID();

            return cloned;
        },
        /**
         * Edit component click handler
         * @param Object item
         */
        editComponentHandler(item) {
            this.editableComponent = item;
            this.editableUid = item.uid;
            // this.editableTag = event.component.tag;
            this.$refs.componentEditor.open();
        },
        /**
         * Save component changes handler
         *
         * @param Object event
         */
        saveComponentHandler(event) {
            // iterate over output
            // check for UID match
            // when match is found - update
            // we can edit only few values of main component keys
            this.iterateComponentArray(this.output, [], event, "params");
        },
        /**
         * Render html from json at single component level
         *
         * @param Object item
         */
        renderHandler(item) {
            this.renderedOutput = this.componentRenderer(item);
        },
        componentRenderer(item) {
            this.rederedComponent = item.id;
            let tmp = [];
            tmp.push(`<template>`);
            tmp.push(`${this.renderComponent(item, 0, true)}`);
            tmp.push(`</template>`);

            // starting script section
            tmp.push(`<script>`);

            // component name will be generated like this
            // if there is prop name and it is not empty - use capitalize(item.prop.name)
            // else use capitalize(item.id)+item.uid
            let rootName = `${this.capitalize(item.id)}${item.uid}`;
            if (item.props) {
                item.props.forEach(prop => {
                    if (prop.name === "page-name" && prop.value != "") {
                        rootName = this.capitalize(prop.value);
                    }
                    if (prop.name === "name" && prop.value != "") {
                        rootName = this.capitalize(prop.value);
                    }
                });
            }

            // childs will be used in few places
            // call function for getting all direct child UID's
            let childs = this.findDirectChildsUID(this.output, item.uid);

            // render import stuff
            // usual import statement can have few formats
            // a) import draggable from "vuedraggable";     -- importing from node_modules
            // b) import MainNav from "@/components/Nav";   -- importing from component in same project
            // c) import { FormSelectPlugin } from 'bootstrap-vue'  -- importing one or few plugins from library
            //
            // import link formula
            // `import ${import.name} from "${import.path}"`

            // after importing we need to register component in one of few possible ways
            // a) Vue.component('b-form-select', BFormSelect)   -- import globaly in app level
            // b) Vue.use(FormSelectPlugin)                     -- import as plugin
            // c) components: {   MainNav,...  }                -- define localy in component who imports and uses it
            //
            // declaration formula
            // `components: {`
            // `  ${component.tag}: ${import.name}`
            // `}`
            // import is applicable only for childs of the main component
            let importStrings = [];
            let componentRegistrations = [];
            childs.forEach(child => {
                if (this.componentImportStrings[child] !== undefined) {
                    // console.log(
                    //     "child",
                    //     child,
                    //     this.componentRegistrationStrings[child]
                    // );
                    importStrings.push(this.componentImportStrings[child]);
                    componentRegistrations.push(
                        this.componentRegistrationStrings[child]
                    );
                }
            });

            if (importStrings.length) {
                tmp.push(`${importStrings.join("\n")}`);
            }

            tmp.push(`export default {`);
            tmp.push(`  name: "${rootName}",`);

            // check for component registrations
            if (componentRegistrations.length) {
                tmp.push(`  components: {`);
                tmp.push(`    ${componentRegistrations.join(",\n    ")}`);
                tmp.push(`  },`);
            }

            tmp.push(`  props: {`);
            tmp.push(`    ${this.renderOptions.props.join(",\n    ")}`);
            tmp.push(`  },`);

            // then check for itemData with filtered UID's
            // if childs are found - add as data prorps
            let renderData = [];
            let renderComputed = [];
            childs.forEach(child => {
                if (this.itemData[child] !== undefined) {
                    // @todo: perform some unique check
                    renderData.push(this.itemData[child]);
                }
                if (this.itemComputed[child] !== undefined) {
                    // @todo: perform some unique check
                    renderComputed.push(this.itemComputed[child]);
                }
            });

            if (renderData.length) {
                tmp.push(`  data() {`);
                tmp.push(`    return {`);
                tmp.push(`      ${renderData.join("\n      ")}`);
                tmp.push(`    }`);
                tmp.push(`  },`);
            }

            if (renderComputed.length) {
                tmp.push(`  computed: {`);
                tmp.push(`    ${renderComputed.join("\n    ")}`);
                tmp.push(`  },`);
            }

            if (
                this.renderOptions.methods &&
                this.renderOptions.methods.length
            ) {
                tmp.push(`  methods: {`);
                tmp.push(`    ${this.renderOptions.methods.join(`\n    `)}`);
                tmp.push(`  }`);
            }

            tmp.push(`};\n<\/script>`);

            return tmp.join("\n");
        },

        /**
         * Function for renderng array of components, like slot content.
         *
         * @param Array componentArray
         * @param number componentArray
         * @returns string
         */
        renderComponentArray(componentArray, level) {
            if (!componentArray.length) {
                return "";
            }

            let result = [];
            componentArray.forEach(componentItem => {
                // console.log("componentItem to render", componentItem);
                switch (componentItem.importAs) {
                    case "text":
                        result.push(componentItem.props[0].value);
                        // @todo: inline stuff also can have a slots and props and we need to render them accordingly
                        break;
                    case "inline":
                        result.push(
                            `${this.renderComponent(componentItem, level + 1)}`
                        );
                        break;
                    default:
                        result.push(
                            `${this.renderComponent(componentItem, level + 1)}`
                        );
                        break;
                }
            });

            return result.join(`\n`); //${this.tabByLevel(0, level)}`);
        },

        tabByLevel(startAt, level) {
            let out = [];
            for (let i = 0; i < startAt + level; i++) {
                out.push("  ");
            }

            return out.join("");
        },

        /**
         * Will generate component import string for given component
         * @param Object componentObject
         * @returns String
         */
        generateImportString(componentObject) {
            if (!componentObject.importName || !componentObject.importPath) {
                return false;
            }

            let importString = "";
            switch (componentObject.importAs) {
                case "local":
                    importString = `import ${
                        componentObject.importName
                    } from "${this.componentImportBase +
                        componentObject.importPath}";`;
                    break;
                case "module":
                    importString = `import ${componentObject.importName} from "${componentObject.importPath}";`;
                    break;
                case "lib":
                    importString = `import { ${componentObject.importName} } from "${componentObject.importPath}";`;
                    break;
                case "inline":
                    // no import is neccesarry - native html stuff
                    break;
            }

            return importString;
        },

        /**
         * Will generate slot content
         *
         * @param Object componentObject
         * @param Boolean asRoot
         * @param Number level
         * @returns Array
         */
        generateSlots(componentObject, asRoot, level) {
            let itemSlotContent = [];
            if (!componentObject.slots) {
                return itemSlotContent;
            }

            let slotKeys = Object.keys(componentObject.slots);
            if (!slotKeys.length) {
                return itemSlotContent;
            }

            slotKeys.forEach(item => {
                // console.log("slot item", item, componentObject.slots[item]);

                // if not asRoot and level > 0 - render just empty slots
                if (asRoot && level > 0) {
                    itemSlotContent.push(
                        `${this.tabByLevel(0, level)}<template ${
                            item !== "default" ? 'slot="${item}"' : ""
                        }></template>`
                    );

                    return;
                }

                let slotContent = this.renderComponentArray(
                    componentObject.slots[item],
                    level
                );
                if (!slotContent.length) {
                    return;
                }

                if (item !== "default") {
                    itemSlotContent.push(
                        `${this.tabByLevel(0, level)}<template slot="${item}">`
                    );
                }
                // console.log("componentObject", componentObject);

                itemSlotContent.push(
                    `${this.tabByLevel(1, level)}${slotContent}`
                );
                if (item !== "default") {
                    itemSlotContent.push(
                        `${this.tabByLevel(0, level)}</template>`
                    );
                }
            });

            return itemSlotContent;
        },

        /**
         * Will generate props for root component
         *
         * @param Object componentObject
         * @returns Array
         */
        generateRootProps(componentObject) {
            if (!componentObject.props.length) {
                return [];
            }

            let resultProps = [];
            // componentObject.props.forEach(componentProp => {
            componentObject.props.forEach(prop => {
                // skipping listeners for now
                if (prop.renderOption === "listener") {
                    return;
                }

                // skipping - this should be added only as a tag attribute
                if (prop.renderOption === "htmlAttribute") {
                    return;
                }

                let propTmp = [];
                //  @todo: convert to camelCase
                propTmp.push(`${this.toCamelCase(prop.name)}: {`);
                propTmp.push(`      type: ${prop.type},`);
                // default value by type
                switch (prop.type) {
                    case "String":
                        propTmp.push(`      default: "${prop.defaultValue}"`);
                        break;
                    case "Number":
                        propTmp.push(`      default: ${prop.defaultValue}`);
                        break;
                    case "Object":
                        if (!prop.defaultValue.length) {
                            propTmp.push(`      default: () => {}`);
                        } else {
                            propTmp.push(`      default: ${prop.defaultValue}`);
                        }
                        break;
                    case "Boolean":
                        propTmp.push(`      default: ${prop.defaultValue}`);
                        break;
                    case "Array":
                        propTmp.push(
                            `      default: ${
                                prop.defaultValue.length
                                    ? prop.defaultValue
                                    : "() => []"
                            }`
                        );
                        break;
                }
                propTmp.push(`    }`);
                resultProps.push(propTmp.join("\n"));
            });

            return resultProps;

            // if (itemData.length) {
            //     // console.log("item data", componentObject.uid, itemData);
            //     this.itemData[componentObject.uid] = itemData;
            // }
            // if (itemComputed.length) {
            //     // console.log(
            //     //     "item computed",
            //     //     componentObject.uid,
            //     //     itemComputed
            //     // );
            //     this.itemComputed[componentObject.uid] = itemComputed.join(
            //         "\n    "
            //     );
            // }
        },

        /**
         * Will generate props for simple component
         *
         * @param Object componentObject
         * @param Boolean asRoot
         * @returns Array
         */
        generateProps(componentObject, asRoot = false) {
            if (!componentObject.props.length) {
                return [];
            }

            let resultProps = [];
            // componentObject.props.forEach(componentProp => {
            componentObject.props.forEach(prop => {
                // asRoot - should bypass only htmlAttribute
                if (asRoot && prop.renderOption !== "htmlAttribute") {
                    return;
                }

                // skipping listeners for now
                if (prop.renderOption === "listener") {
                    return;
                }

                // non root stuff - put props as attributes on some tag
                let propTmp = "";
                switch (prop.renderOption) {
                    case "htmlAttribute":
                        // basically here we should also check for the type and make use of bindings
                        // but we stick only for statick text for now
                        propTmp = `${prop.name}="${prop.value}"`;
                        break;
                    case "static":
                        // check type here also
                        switch (prop.type) {
                            case "Boolean":
                                if (prop.value === "true") {
                                    propTmp = `${prop.name}`;
                                }
                                break;
                            default:
                                propTmp = `${prop.name}="${prop.value}"`;
                                break;
                        }
                        break;
                    case "dynamic":
                        propTmp = `:${prop.name}="${prop.value}"`;
                        break;
                    case "noValue":
                        propTmp = `${prop.name}`;
                        break;
                    case "boolean":
                        if (prop.value === "true") {
                            propTmp = `${prop.name}`;
                        }
                        break;
                    case "listener":
                        propTmp = `@${prop.name}="${prop.value}"`;
                        break;
                }
                resultProps.push(propTmp);
            });

            return resultProps;
        },

        /**
         * This will check if component should be imported
         */
        isImportable(componentObject) {
            return (
                componentObject.importAs !== "inline" &&
                componentObject.importAs !== "text"
            );
        },

        /**
         * Function for rendering component
         *
         * @param Object componentObject
         * @param Number level
         * @param Boolean asRoot, default false
         * @returns string
         */
        renderComponent(componentObject, level, asRoot = false) {
            if (asRoot) {
                this.resetRenderOptions();
            }
            let itemProps = [];
            let itemData = [];
            let itemComputed = [];
            // console.log('componentObject', componentObject);

            // if there is some importPath and importName - we need to create import string
            if (
                componentObject.importName !== undefined &&
                componentObject.importPath !== undefined
            ) {
                // registration is the same for all import cases except inline native components
                if (this.isImportable(componentObject)) {
                    this.componentImportStrings[
                        componentObject.uid
                    ] = this.generateImportString(componentObject);

                    // component registration string will be used when registering component somewere
                    this.componentRegistrationStrings[
                        componentObject.uid
                    ] = `"${componentObject.tag}": ${componentObject.importName}`;
                }
            }

            let itemSlotContent = this.generateSlots(
                componentObject,
                asRoot,
                level
            );

            if (componentObject.props.length) {
                if (asRoot) {
                    let propTmp = this.generateRootProps(componentObject);
                    this.renderOptions.props.push(propTmp.join(",\n"));
                    itemProps = this.generateProps(componentObject, asRoot);
                } else {
                    itemProps = this.generateProps(componentObject);
                }
                // componentObject.props.forEach(componentProp => {
                componentObject.props.forEach(prop => {
                    if (asRoot) {
                        // skipping listeners for now
                        if (prop.renderOption === "listener") {
                            return;
                        }
                    } else {
                        //  requires special - means requires some kind of binding
                        if (prop.requiresSpecial) {
                            let propValueByType = null;
                            switch (prop.requiresSpecial) {
                                case "data":
                                    switch (prop.type) {
                                        case "String":
                                            propValueByType =
                                                prop.defaultValue || "";
                                            break;
                                        case "Number":
                                            propValueByType =
                                                prop.defaultValue || 0;
                                            break;
                                        case "Object":
                                            propValueByType =
                                                prop.defaultValue || "{}";
                                            break;
                                        case "Array":
                                            propValueByType =
                                                prop.defaultValue || "[]";
                                            break;
                                    }
                                    itemData.push(
                                        `${prop.value}: ${propValueByType}`
                                    );
                                    break;
                                case "computed":
                                    itemComputed.push(
                                        `${prop.value}: function () {`
                                    );
                                    itemComputed.push(
                                        `  return 'a + b goes here';`
                                    );
                                    itemComputed.push(`}`);
                                    break;
                            }
                        }

                        if (prop.requiresMethod) {
                            this.renderOptions.methods.push(
                                `${prop.value}(e) {`
                            );
                            this.renderOptions.methods.push(
                                `// eslint-disable-next-line no-console`
                            );
                            this.renderOptions.methods.push(
                                `  console.log('event listener for ${prop.value} was hit, go ahead and put some stuff here', e);`
                            );
                            this.renderOptions.methods.push(`  return true;`);
                            this.renderOptions.methods.push(`}`);
                        }
                    }
                });

                if (itemData.length) {
                    // console.log("item data", componentObject.uid, itemData);
                    this.itemData[componentObject.uid] = itemData;
                }
                if (itemComputed.length) {
                    // console.log(
                    //     "item computed",
                    //     componentObject.uid,
                    //     itemComputed
                    // );
                    this.itemComputed[componentObject.uid] = itemComputed.join(
                        "\n    "
                    );
                }
            }

            let generatedOut = [];
            // note: if asRoot - props should be rendered in props section and not in a tag itself
            // level ++;
            // todo: basically this all stuff should not be rendered if component is not in root level - just replace with empty slot
            if (itemSlotContent.length) {
                // console.log(
                //     "componentObject.tag",
                //     componentObject.tag,
                //     componentObject.importAs,
                //     itemSlotContent
                // );
                // opening tag
                generatedOut.push(
                    `${this.tabByLevel(1, level)}<${
                        asRoot ? "div" : componentObject.tag
                    } ${itemProps.join(" ")}>`
                );
                // generatedOut.push(`${this.tabByLevel(2, level)}${itemSlotContent.join('\n'+this.tabByLevel(1, level))}`);

                // inner content
                generatedOut.push(
                    `${this.tabByLevel(2, level)}${itemSlotContent.join(
                        "\n" + this.tabByLevel(2, level)
                    )}`
                );

                // closing tag
                generatedOut.push(
                    `${this.tabByLevel(1, level)}</${
                        asRoot ? "div" : componentObject.tag
                    }>`
                );

                return generatedOut.join("\n");
            }

            // generatedOut.push(`    ${itemSlotContent.join("")}`);
            // console.log("compo", componentObject);

            if (componentObject.selfClosing) {
                generatedOut.push(
                    `${this.tabByLevel(1, level)}<${
                        asRoot ? "div" : componentObject.tag
                    } ${itemProps.join(" ")} />`
                );
            } else {
                generatedOut.push(
                    `${this.tabByLevel(1, level)}<${
                        asRoot ? "div" : componentObject.tag
                    } ${itemProps.join(" ")}></${
                        asRoot ? "div" : componentObject.tag
                    }>`
                );
            }

            return generatedOut.join(`\n${this.tabByLevel(-1, level)}`);
        },
        addAttributeHandler(event) {
            const d = new Date();
            event.component.props.push({
                name:
                    "default-name-" +
                    d.getSeconds() +
                    "-" +
                    d.getMilliseconds(),
                type: "String",
                value: "",
                defaultValue: "",
                renderOption: "static"
            });
        },
        editAttributeHandler(event) {
            this.editableAttribute = event.attribute;
            this.editableUid = event.component.uid;
            this.editableTag = event.component.tag;
            this.$refs.propertyEditor.open();
        },
        removePropertyHandler(event) {
            let res = this.iterateComponentArray(
                this.output,
                [],
                {
                    old: event.prop,
                    new: false
                },
                "props"
            );
            // console.log("removal result", res);
        },
        resetRenderOptions() {
            this.renderOptions = {
                data: [],
                props: [],
                methods: []
            };
        },
        savePropertyHandler(event) {
            // array of objects [compoonent, component, ...]
            // 1. check uid - T: update
            // F: check slots - T: -> 2
            // F: continue to next array element
            //
            // 2. object of keys (slots: default: [], footer: [])
            // array of slot[key] -> 1

            this.iterateComponentArray(this.output, [], event, "props");
            const a = this.output;
            this.output = [];
            this.$nextTick(() => {
                this.output = a;
            });
        },
        iterateComponentArray(
            componentArray,
            dataLocation,
            changes,
            changeType
        ) {
            if (!componentArray || !componentArray.length) {
                return false;
            }

            for (let i = 0; i < componentArray.length; i++) {
                // continue itteration until match is found (true is returned)
                let arrayResult = this.updateComponentRecursively(
                    componentArray[i],
                    [...dataLocation, i],
                    changes,
                    changeType
                );
                if (arrayResult) {
                    componentArray[i] = arrayResult;
                    return componentArray; //true;
                }
            }

            return false;
        },
        /**
         * Component updater
         *
         * @param Object componentObject
         * @param Array dataLocation - ['root', 0, 'slots', 1]
         * @param Object changes - { old:{}, new:{} }
         * @param String changeType - "props/params"
         */
        updateComponentRecursively(
            componentObject,
            dataLocation,
            changes,
            changeType
        ) {
            if (componentObject.uid === this.editableUid) {
                switch (changeType) {
                    case "props":
                        // do property lookup and update
                        componentObject.props = this.updateComponentPropsArray(
                            componentObject.props,
                            [...dataLocation, "props"],
                            changes
                        );
                        break;
                    case "params":
                        // do params lookup and update
                        componentObject = this.updateComponentParams(
                            componentObject,
                            changes
                        );
                        this.componentParamsChanged++;
                        break;
                }
                return componentObject; //true;
            }

            // no slots
            if (!componentObject.slots) {
                return false;
            }

            let slotsKeyArray = Object.keys(componentObject.slots);
            // empty slots
            if (!slotsKeyArray.length) {
                return false;
            }

            // iterate slots
            for (let i = 0; i < slotsKeyArray.length; i++) {
                let slotResult = this.iterateComponentArray(
                    componentObject.slots[slotsKeyArray[i]],
                    [...dataLocation, "slots", slotsKeyArray[i]],
                    changes,
                    changeType
                );
                if (slotResult) {
                    componentObject.slots[slotsKeyArray[i]] = slotResult;
                    return componentObject;
                }
            }

            return false;
        },

        updateComponentPropsArray(propsArray, dataLocation, changes) {
            if (!propsArray || !propsArray.length) {
                return false;
            }

            for (let i = 0; i < propsArray.length; i++) {
                if (
                    propsArray[i].name &&
                    propsArray[i].name === changes.old.name
                ) {
                    if (changes.new) {
                        propsArray[i] = changes.new;
                    } else {
                        // remove proprerty
                        propsArray.splice(i, 1);
                    }

                    return propsArray;
                }
            }

            return false;
        },

        /**
         * Will return updated component object
         *
         * @param componentObject
         * @param changes
         */
        updateComponentParams(componentObject, changes) {
            // should return updated component object
            return { ...componentObject, ...changes.new };
        },

        // dynamicGet(path, obj) {
        //   return path.reduce(function(prev, curr) {
        //       return prev ? prev[curr] : null
        //   }, obj || self)
        // },
        removeItemHandler(item) {
            this.output = this.removeNested(this.output, item);
        },
        removeNested(obj, item) {
            obj.forEach(rootElement => {
                if (
                    rootElement.slots !== undefined &&
                    Object.keys(rootElement.slots).length
                ) {
                    Object.keys(rootElement.slots).forEach(element => {
                        return (rootElement.slots[element] = this.removeNested(
                            rootElement.slots[element],
                            item
                        ));
                    });
                }
            });

            return obj.filter(items => items.uid !== item.uid);
        },
        capitalize(value) {
            if (!value) return "";
            value = value.toString();
            return value.charAt(0).toUpperCase() + value.slice(1);
        },
        /**
         * Converts string from dash-case to camelCase
         */
        toCamelCase(value) {
            let parts = value.split("-");
            let result = parts[0];
            parts.shift();
            parts = parts.map(part => {
                return this.capitalize(part);
            });

            return result + parts.join("");
        },
        /**
         * Lookup for first level childs
         * @param number rootUid
         */
        findDirectChildsUID(componentArray, rootUid) {
            let childs = [];
            componentArray.forEach(rootEl => {
                if (
                    rootEl.uid === rootUid &&
                    rootEl.slots &&
                    Object.keys(rootEl.slots).length
                ) {
                    let slots = Object.keys(rootEl.slots);
                    slots.forEach(slot => {
                        if (rootEl.slots[slot].length) {
                            childs = [
                                ...this.getUidsFromArray(rootEl.slots[slot]),
                                ...childs
                            ];
                        }
                    });
                }
            });

            return childs;
        },

        getUidsFromArray(componentArray) {
            let result = [];
            componentArray.forEach(component => {
                result.push(component.uid);
                if (component.slots && Object.keys(component.slots).length) {
                    Object.keys(component.slots).forEach(slotName => {
                        if (component.slots[slotName].length) {
                            result = [
                                ...this.getUidsFromArray(
                                    component.slots[slotName]
                                ),
                                ...result
                            ];
                        }
                    });
                }
            });

            return result;
        },

        generateUUID() {
            // UUIDv4
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
                return v.toString(16);
            });
        }
    }
    // watch: {
    //     componentParamsChanged(val) {
    //         if (val) {
    //             this.output = JSON.parse(JSON.stringify(this.output));
    //             this.componentParamsChange = false;
    //         }
    //     }
    // }
};
</script>
